import { PillProps } from '@Components/Pill';
import { AuctionAuctionType, AuctionFragment, AuctionStatus, MyAuctionFragment } from '@Graphql/graphqlTypes.generated';
import { convertCentsToMoney } from '@Utils/money';

export const getPillTypeByAuctionType = (type: AuctionAuctionType): PillProps['type'] => {
  switch (type) {
    case AuctionAuctionType.Sale:
      return 'yellow';
    case AuctionAuctionType.Purchase:
      return 'blue';
    default:
      return undefined;
  }
};

export const getLastBid = (auction: AuctionFragment) => {
  const { lastBids } = auction;

  if (!lastBids.length) {
    return null;
  }
  const amount = lastBids[0] && lastBids[0].amount;
  return convertCentsToMoney(amount);
};

export const isBiddingEnabled = (auction: AuctionFragment | MyAuctionFragment) => {
  const auctionItem = (auction as MyAuctionFragment)?.auction || auction;

  return auctionItem.status === AuctionStatus.Approved;
};
